'use strict';

import { error as responseError, success as responseSuccess } from '@itbelcom/check-response';
import CrossPost, { parse, stringify, genId, equalData, getEventListeners, l } from '@itbelcom/cross-post';
import { E, E$ } from '@itbelcom/custom-error';


/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * ОЧЕНЬ ВАЖНО:
 *   Не обращаться к свойствам и методам, начинающимся с символов  "_", "$" - это приватные данные и методы.
 *   Не обращаться напрямую к данным, использующимся этим сервисом в sessionStorage, localStorage или иных хранилищах.
 *   Для работы с такими данными использовать ТОЛЬКО ПУБЛИЧНЫЕ методы и свойства объекта.
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Терминология:
 *  Под "пустым" объектом данных понимать объект содержащий только служебные поля начинающиеся на "$".
 *  Под вкладкой понимать отдельную вкладку с экземпляром NBRBAuth2 или ифрейм с NBRBAuth2.
 *
 *
 * Сервис аутентификации.
 * @constructor
 * @param {Object} o - Опции:
 *   {function} ajax - Сервис для ajax-запросов.
 *   {boolean} [autoRefresh=true] - Определяет, будет ли токен обновлятся автоматически по таймеру.
 *   {string} baseUrl - Адрес веб-сервиса аутентификации.
 *   {boolean} [debug=false] - Включить/выключить режим отладки: вывод информации в консоль.
 *   {number} [httpRequestTimeout=3000] - Таймаут ожидания ответа от сервера на запрос получения новых токенов.
 *   {string} [idleActions='click keypress'] - Список действий пользователя (через пробел),
 *            которые сбрасывают (обнуляют) таймер бездействия:
 *                если idleActions не указано, то таймер бездействия не устанавливаем и ничего не делаем.
 *   {number} [idleActionsThrottleTimeout=5*1000] - ms, На сколько задерживать отсылку оповещения другим вкладкам
 *            после действия пользователя (см.idleActions).
 *            Величина должна быть меньше <idleTimeout>.
 *   {number} [idleAlarm=1*60*1000] - ms, За какой момент времени до автоматического разлогирования
 *            при бездействии пользователя (см.idleTimeout) генерировать событие ON_IDLE_ALARM:
 *                если <= 0, то таймер бездействия не устанавливаем и ничего не делаем;
 *                если >= idleTimeout, то таймер бездеуствия не устанавливаем и ничего не делаем.
 *   {number} [idleTimeout=30*60*1000] - ms, Время бездействия пользователя (см.idleActions),
 *            после которого разлогиниваемся:
 *                если <= 0, то таймер не устанавливаем и ничего не делаем.
 *   {number} [maxAge=-1] - ms, Время жизни токена:
 *                если <= 0, то используется MaxAgeMilliseconds возвращаемое сервером;
 *                если и оно не указано, то генерируем исключение.
 *   {number} [maxAgeDelta=60*1000] - ms, Насколько заблаговременно начать процесс обновления токена.
 *   {boolean} [withCredentials=false] - Позволяет нам использовать в запросе к серверу user-credentials.
 *   {boolean} [mismatchAlert=false] - Определяет, будет ли показываться алерт
 *            с предупреждением о не соответствии версий модулей, либо вывод будет только в консоль.
 *   {Object} crossPost - Настройки модуля для обмена сообщениями: @itbelcom/cross-post.
 */
export function NBRBAuth2(o) {
    /**
     * Здесь указываем пакеты, у которых будем контролировать соответствие версий во вкладках и ифреймах,
     * если версии не соответствуют то в консоль пишем предупреждени и,
     * если <mismatchAlert = true> - будет показан alert с соответствующим сообщением.
     */
    /* проверка версий пакетов убрана в версии 0.1.13
    this._packages = [
        require('@itbelcom/check-response/package.json'),
        require('@itbelcom/custom-error/package.json'),
        require('@itbelcom/cross-post/package.json'),
        require('@itbelcom/nbrb-auth2/package.json'),
        require('broadcast-channel/package.json'),
        require('post-robot/package.json')
    ].reduce(function(r, p) {
        r[p.name] = p.version;
        return r;
    }, {});
    */

    this._options = Object.assign({
        ajax: null,
        autoRefresh: true,
        baseUrl: '',
        debug: false,
        httpRequestTimeout: 3000,
        idleActions: 'click keypress',
        idleActionsThrottleTimeout: 5*1000,
        idleAlarm: 1*60*1000,
        idleTimeout: 30*60*1000,
        maxAge: -1, // ms, время жизни сессии;
                    // если <= 0, то используется MaxAgeMilliseconds возвращаемое сервером;
                    // если и оно не указано, то генерируем исключение.
        maxAgeDelta: 60 * 1000, // ms, на сколько заблаговременно начать процесс обновления токена;
        mismatchAlert: false,
        withCredentials: false,
    }, o);

    if (!this._options.baseUrl) {
        throw new Error('<baseUrl> option is required.');
    }

    if (typeof this._options.ajax !== 'function') {
        throw new Error('<ajax> option is not valid.');
    }

    this._events = {};

    /**
     * Активный таймер для работы с данными у нас может быть только один, поэтому только один общий ID.
     */
    this._timerID = 0;

    /**
     * Для таймеров бездействия пользователя(idleTimeout) и предупреждения(idleAlarm) выделяем отдельные ID,
     * так как они не зависим от таймера связанного с данными.
     */
    this._idleAlarmTimerID = 0;
    this._idleTimeoutTimerID = 0;

    this._DATA_ = genData(); // !!!_DATA_ напрямую не использовать!!!
    this._dataDefer = createDefer();

    /**
     * Настраиваем пересылку сообщений:
     */
    this._crossPost = new CrossPost(Object.assign({
        //_packages: this._packages,
        debug: this._options.debug
    }, this._options.crossPost));

    this._crossPost.on(this._crossPost.typeConstants.DATA, this._onData.bind(this));
    this._crossPost.on(this._crossPost.typeConstants.ELECTION, this._onElection.bind(this));
    this._crossPost.on(this._crossPost.typeConstants.PROMOTE, this._onPromote.bind(this));
    this._crossPost.on(this._crossPost.typeConstants.REQUEST, this._onRequest.bind(this));
    this._crossPost.on(this._crossPost.typeConstants.RESPONSE, this._onResponse.bind(this));

    this._storageKey = 'NBRBAuth2_DATA_' + this._crossPost._channelName;

    this._reset(true);///////НЕ НАДО СЛАТЬ!!!
    this.checkAccess().catch(noop);

    if (this._options.idleActions && (this._options.idleTimeout > 0)) {
        this._crossPost.on(this._typeConstantsEx.ACTION, this._onAction.bind(this));
        this._resetIdleTimeoutTimer();

        var throttleActionHandler = throttle(function(event) {
            l('@nbrb-auth2', 'eventListener: ' + this._options.idleActions + '; event.type=' + event.type);
            this._resetIdleTimeoutTimer();
            if (this._crossPost) {
                this._crossPost.send(null, this._typeConstantsEx.ACTION);
            }
        }.bind(this), this._options.idleActionsThrottleTimeout);

        this._options.idleActions.split(/\s+/).forEach(function(action) {
            document.addEventListener(action, throttleActionHandler, true);
        });
    }
};


/**
 * @private
 */
NBRBAuth2.prototype._errorName = 'NBRBAuth2Error';


/**
 * @private
 */
NBRBAuth2.prototype._onAction = function(data, meta) {
    l(['@nbrb-auth2', 0], 'on->ACTION: data=' + data + '; meta=', meta);
    this._resetIdleTimeoutTimer();
    if (meta) {
        this._crossPost._sendInternal({data: data, meta: meta}, true);
    }
    return true;
}; /* _onAction */


/**
 * @private
 */
NBRBAuth2.prototype._onData = function(data, meta) {
    l(['@nbrb-auth2', 0], 'on->DATA: equal=' + (equalData(this._DATA_, data) ? 'true ' : 'false') + '; _DATA_=', this._DATA_, '; data =', data);
    if (!equalData(this._DATA_, data)) {
        this._setData(data, true);
    }
    return true;
}; /* _onData */


/**
 * @private
 */
NBRBAuth2.prototype._onElection = function(data, meta) {
    l(['@nbrb-auth2', 5], 'on->ELECTION: isLeader=' + (this._crossPost.isLeader() ? 'true ' : 'false') + '; _channelName=' + this._crossPost._channelName + '; _channelId=' + this._crossPost._id + '; _leaderId=' + this._crossPost._leaderId);
    if (this._crossPost.isLeader()) {
        this.refresh();
    }
    return true;
}; /* _onElection */


/**
 * @private
 */
NBRBAuth2.prototype._onPromote = function(data, meta) {
    l(['@nbrb-auth2', 14], 'on->PROMOTE: _channelName=' + this._crossPost._channelName + '; _channelId=' + this._crossPost._id + '; data =', data);
    /**
     * Если начались выборы, то останавливаем текущий таймер выборов
     * и запускаем таймер ожидания данных,
     * который в свою очередь начнет новые выборы если данных не дождались.
     * Время ожидания складывается из:
     *   - таймаута выборов;
     *   - таймаута ожидания ответа от сервера на запрос получения новых токенов;
     *   - и небольшой случайной величины,
     *     которая позволит не конкурировать таймерам на разных вкладках;
     *     лидерство в данном случае не проверяем, так как если этот таймер сработал,
     *     то с лидером уже что-то произошло.
     */
    var waitTimeout = this._crossPost._electionTimeout + this._options.httpRequestTimeout + Math.floor(1000 * Math.random());

    this._stopTimer();
    this._timerID = window.setTimeout(function() {
        l(['@nbrb-auth2', 4], '_startRefresh(): runElection');
        this._stopTimer();
        this._crossPost.runElection();
    }.bind(this), waitTimeout);

    return true;
}; /* _onPromote */


/**
 * @private
 */
NBRBAuth2.prototype._onRequest = function(data, meta) {
    //checkPackages(this._packages, meta.packages, meta.sourceId, this._options.mismatchAlert);
    /**
     * Если получили запрос на данные, то это значит, что пользователь открыл(обновил) новую вкладку,
     * и соответственно не бездействует.
     */
    this._resetIdleTimeoutTimer();
    return true;
}; /* _onRequest */


/**
 * @private
 */
NBRBAuth2.prototype._onResponse = function(data, meta) {
    //checkPackages(this._packages, meta.packages, meta.sourceId, this._options.mismatchAlert);
    return true;
}; /* _onResponse */


/**
 * Возвращает Id модуля(вкладки/ифрейма)
 * @public
 */
NBRBAuth2.prototype.getId = function() {
    return this._crossPost._id;
}; /* getId */


/**
 * @private
 */
NBRBAuth2.prototype._reset = function(withData) {
    this._stopTimer();
    this._resetData(withData);
}; /* _reset */



/**
 * @private
 */
NBRBAuth2.prototype._stopIdleAlarmTimer = function() {
    l('@nbrb-auth2', '_stopIdleAlarmTimer(): _idleAlarmTimerID =', this._idleAlarmTimerID);
    if (this._idleAlarmTimerID) {
        window.clearTimeout(this._idleAlarmTimerID);
        this._idleAlarmTimerID = 0;
    }
}; /* _stopIdleAlarmTimer */


/**
 * @private
 */
NBRBAuth2.prototype._stopIdleTimeoutTimer = function() {
    l('@nbrb-auth2', '_stopIdleTimeoutTimer(): _idleTimeoutTimerID =', this._idleTimeoutTimerID);
    this._stopIdleAlarmTimer();
    if (this._idleTimeoutTimerID) {
        window.clearTimeout(this._idleTimeoutTimerID);
        this._idleTimeoutTimerID = 0;
    }
}; /* _stopIdleTimeoutTimer */


/**
 * @private
 */
NBRBAuth2.prototype._resetIdleTimeoutTimer = function() {
    l('@nbrb-auth2', '_resetIdleTimeoutTimer(): _idleTimeoutTimerID =', this._idleTimeoutTimerID);
    this._stopIdleTimeoutTimer();
    if (this._options.idleTimeout > 0) {
        if ((this._options.idleAlarm > 0) && (this._options.idleAlarm < this._options.idleTimeout)) {
            this._idleAlarmTimerID = window.setTimeout(function() {
                this._stopIdleAlarmTimer();
                this.emit(this.eventConstants.ON_IDLE_ALARM, null);
            }.bind(this), this._options.idleTimeout - this._options.idleAlarm);
        }
        this._idleTimeoutTimerID = window.setTimeout(function() {
            this._stopIdleTimeoutTimer();
            this.logout(true);
        }.bind(this), this._options.idleTimeout);
    }
}; /* _resetIdleTimeoutTimer */


/**
 * Проверяет дату истечения токена, если входящее значение не задано или токен истек, то вернет 0.
 * @private
 * @returns {Integer} Возвращает дату истечения токена.
 */
NBRBAuth2.prototype._checkTokenExpires = function(tokenExpires) {
    return ((tokenExpires > Date.now()) && tokenExpires) || 0;
}; /* _checkTokenExpires */


/**
 * @private
 */
NBRBAuth2.prototype._checkAuthTokenTimeout = function(tokenExpires) {
    var authTokenExpires = this._checkTokenExpires(tokenExpires);
    var maxAge = this._options.maxAge > 0 ? this._options.maxAge : (authTokenExpires - Date.now());

    if (maxAge < 0) {
        console.warn('@itbelcom/nbrb-auth2: Токен отсутствует или истёк!');
        return -1;
    } else if (maxAge > (this._options.maxAgeDelta + 1000)) {
        maxAge = maxAge - this._options.maxAgeDelta;
    } else {
        maxAge = Math.floor(maxAge / 2);
    }

    if (maxAge < 1000) {
        console.warn('@itbelcom/nbrb-auth2: Очень короткое время жизни токена!');
    }
    if (!this._crossPost.isLeader()) {
        /**
         * Если не являемся лидером на данный момент,
         * то искусственно увеличиваем на небольшую случайную величину время запуска таймера
         * для проведения выборов для того, чтобы текущий лидер успел начать выборы ранее и
         * не конкурировать с ним, а также с другими вкладками.
         * Так как если начинаются выборы, то текущий таймер (если есть) останавливается и
         * запускается новый с небольшим интервалом для ожидания получения новых данных,
         * которые будет получать новый лидер с сервера.
         * Если данные не получены в течении данного интервала, то это значит,
         * что со вкладкой лидером не все в порядке: либо закрыли за это время,
         * либо подвисла или другие причины. В этом случае должны начаться новые выборы.
         */
        maxAge += 1000 + Math.floor(1000 * Math.random());
    }
    return maxAge;
}; /* _checkAuthTokenTimeout */


/**
 * Запускает обновление токена по таймеру, если это разрешено и необходимо.
 * @private
 */
NBRBAuth2.prototype._startRefresh = function() {
    this._stopTimer();

    if (this._options.autoRefresh !== true) {
        return this._timerID;
    }

    var authTokenTimeout = this._checkAuthTokenTimeout(this._DATA_.authTokenExpires);
    l(['@nbrb-auth2', 2], '_startRefresh(): authTokenTimeout =', authTokenTimeout);

    if (authTokenTimeout > 0) {
        /**
         * Если есть валидный authToken, то запускаем таймер обновления токенов.
         */
        this._timerID = window.setTimeout(function() {
            l(['@nbrb-auth2', 4], '-------------------------------------------------------------');
            l(['@nbrb-auth2', 4], '_startRefresh(): runElection');
            this._stopTimer();
            this._crossPost.runElection();
        }.bind(this), authTokenTimeout);

        l(['@nbrb-auth2', 3], '_startRefresh(): RUN TIMER!!! _timerID =', this._timerID);
    } else if (this._checkTokenExpires(this._DATA_.authRefreshTokenExpires) > 0) {
        /**
         * Иначе если есть валидный authRefreshToken, то обновляем токены незамедлительно.
         */
        l(['@nbrb-auth2', 3], '_startRefresh(): WITHOUT TIMER!!!');
        this._crossPost.runElection();
    }

    return this._timerID;
}; /* _startRefresh */


/**
 * Остановливает текущий таймер, если он был запущен.
 * @private
 */
NBRBAuth2.prototype._stopTimer = function() {
    l(['@nbrb-auth2', 1], '_stopTimer(): _timerID =', this._timerID);
    if (this._timerID) {
        window.clearTimeout(this._timerID);
        this._timerID = 0;
    }
    return this._timerID;
}; /* _stopTimer */


/**
 * Обработка ответа от сервера в случае ошибки.
 * @private
 * @param {Object} response
 * @returns {Promise} Возвращает промис с ответом от сервера.
 */
NBRBAuth2.prototype._responseErrorReset = function(response) {
    return responseError(response).catch(function(error) {
        return this._setData(error);
    }.bind(this));
}; /* _responseErrorReset */


/**
 * Обработка ответа от сервера случае, когда нужно обработать только успешный результат.
 * К примеру NBRBAuth2.refresh() - плохие ответы не обрабатываем,
 * так как пока текущий токен жив. то это не важно.
 * @private
 * @param {Object} response
 * @returns {Promise} Возвращает промис с полученными данными.
 */
NBRBAuth2.prototype._responseSuccessLogin0 = function(response) {
    var data = response.data;

    if (data.Status !== 0) {
        // Ругаемся, показываем алерт и прерываем выполнение программы,
        // т.к. в данном случае не должны были сюда попасть - ОШИБКА программирования.
        E('Нельзя обработать ответ от сервера, так как он содержит ошибки!', null, this._errorName, 0);
    }

    l('@nbrb-auth2', '_responseSuccessLogin0 1: ' + response.config.url + ': SUCCESS: data =', data);
    // От портала данные об сессии приходят в поле Session,
    // для других приложений на одном уровне с отстальными данными.
    var d = data.Session || data;
    return this._setData({
        // По $id будем сравнивать объекты данных: если $id не совпадают, то объекты данных разные.
        $id: genId(),
        $state: this.stateConstants.READY,
        authRefreshToken: d.AuthRefreshToken,
        authRefreshTokenExpires: Date.now() + d.RefreshMaxAgeMilliseconds,
        authToken: d.AuthToken,
        authTokenExpires: Date.now() + d.MaxAgeMilliseconds,
        keyContainer: d.KeyContainer,
        maxAgeMilliseconds: d.MaxAgeMilliseconds,
        refreshMaxAgeMilliseconds: d.RefreshMaxAgeMilliseconds,
    });
}; /* _responseSuccessLogin0 */


/**
 * @private
 * @param {Object} response
 * @returns {Promise} Возвращает промис с полученными данными.
 */
NBRBAuth2.prototype._responseSuccessLogin = function(response) {
    if (response.data.Status === 0) {
        return this._responseSuccessLogin0(response);
    } else {
        // В данном случае responseSuccess будет только catch!
        return responseSuccess(response).catch(function(error) {
            return this._setData(error);
        }.bind(this));
    }
}; /* _responseSuccessLogin */


/**
 * Проверяет аутентификацию: шлёт запрос вкладкам и ифреймам,
 * и ожидает ответа в течении <crossPost.requestTimeout>.
 * @public
 * @returns {Promise} Возвращает промис с полученными данными или "пустой" объект.
 */
NBRBAuth2.prototype.checkAccess = function() {
    l('@nbrb-auth2', 'checkAccess()');
    return this._crossPost.sendRequest().then(function(response) {
        if (response.isTimeout) {
            /**
             * Если был таймаут - это значит, что никто нам не ответил (вероятно больше вкладок нет);
             * в этом случае пытаемся получить из sessionStorage:
             */
            var data = parse(window.sessionStorage.getItem(this._storageKey), null);
            if (!data || (data.$state !== this.stateConstants.READY)) {
                /**
                 * Если в хранилище нет данных или они не в состоянии готовности ($state = READY),
                 * то проинициализируем новые в состоянии готовности:
                 */
                data = genData(this.stateConstants.READY);
            }
            /**
             * И затем сохраним их у себя и разошлём.
             */
            return this._setData(data);
        }
        /**
         * Иначе, если данные нам пришли от другой вкладки, то только сохраним (без рассылки).
         */
        return this._setData(response.data, true);
    }.bind(this), function(error) {
        var errorMsg = (error && error.errorMsg) || 'Непредвиденная ошибка!';
        return E$(errorMsg + '! Попробуйте обновить страницу.', null, this._errorName, 0);
    }.bind(this)).then(function(data) {
        if (data && (data.errorMsg || data.status)) {
            return Promise.reject(data);
        }
        return data;
    });
}; /* checkAccess */


/**
 * Возвращает сохраненные данные.
 * @public
 * @return {Promise} Промис объекта данных аутентификации или ошибки или "пустой" объект.
 */
NBRBAuth2.prototype.getData = function() {
    return this._dataDefer.promise;
}; /* getData */


/**
 * Устанавливает новые данные и возвращает промис данных.
 * Если текущий промис был зарезолвен, то создаёт новый.
 * Если новые данные получены ($state === READY), то резолвит с новыми данными;
 * Иначе ($state !== READY) возвращает незарезолвенный промис.
 * @private
 * @param {*} data
 */
NBRBAuth2.prototype._setData = function(data, silent) {
    l(['@nbrb-auth2', 10], '_setData(): silent=' + silent
        + '; equal=' + (equalData(this._DATA_, data) ? 'true ' : 'false')
        + '; _DATA_=', this._DATA_, '; data=', data);

    /**
     * Если состояние данных не является LOADING, то будем считать состояние READY.
     * Состояние ($state) может отсутствовать, если данные с сервера получили мы,
     * но если данные получены от другой вкладки, то $state всегда должен быть!
     */
    if (data.$state !== this.stateConstants.LOADING) {
        data.$state = this.stateConstants.READY;
    }
    if (!data.$id) {
        /**
         * Сгенерируем $id, если его нет.
         * $id может отсутствовать, если данные с сервера получили мы,
         * но если данные получены от другой вкладки, то $id всегда должен быть!
         * Если $id не было, то это всегда новые данные.
         */
        data.$id = genId();
    } else if (equalData(this._DATA_, data)) {
        /**
         * Если полученные данные идентичны существующим, то ничего не делаем - игнорируем их.
         */
        return this._dataDefer.promise;
    }

    //var oldToken = this._checkAuthToken(this._DATA_);
    var oldToken = this._DATA_.authToken || null;
    var newToken = this._checkAuthToken(data);

    this._reset();

    l(['@nbrb-auth2', 12], '_setData(): _dataDefer.isPending =', this._dataDefer.isPending);
    this._DATA_ = data;

    var sDATA = stringify(this._DATA_);
    if (typeof this._DATA_ === 'object') {
        window.sessionStorage.setItem(this._storageKey, sDATA);
    } else {
        E('Неверное значение данных!!!', null, this._errorName, 0);
        //window.sessionStorage.removeItem(this._storageKey);
    }

    /**
     * Если $state !== READY - это значит, что данные не определены и ждем получения данных,
     * иначе резолвим промис с полученными данными.
     */
    if (this._DATA_.$state === this.stateConstants.READY) {
        this._dataDefer.resolve(this._DATA_);
    }

    /**
     * Если с данными получили метаинформацию,
     * то значит эти данные получили через рассылку и повторно их рассылать не имеет смысла;
     * Если метаинформации нет, то это данные "наши" и значит их рассылаем.
     */
    //if (silent !== true) {
    this._crossPost.setData(this._DATA_, silent);
    //}

    /**
     * Если данные определены ($state === READY), то шлём события и запускаем таймер,
     * иначе больше ничего не делаем и ждём получения каких-либо данных.
     */
    if (this._DATA_.$state === this.stateConstants.READY) {
        // события
        if (!oldToken && newToken) {
            this.emit(this.eventConstants.ON_LOGIN, parse(sDATA));
        } else if (oldToken && !newToken) {
            this.emit(this.eventConstants.ON_LOGOUT, null);
        } else if (oldToken && (oldToken !== newToken)) {
            this.emit(this.eventConstants.ON_UPDATE, parse(sDATA));
        }

        this._startRefresh();
    }

    l(['@nbrb-auth2', 13], '_setData(): END');
    return this._dataDefer.promise;
}; /* _setData */


/**
 * Сбрасывает текущие данные, если withData === true,
 * и возвращает незарезолвенный промис текущих данных (!всегда!).
 * @private
 * @returns {Promise} Возвращает незарезолвенный промис текущих данных (!всегда!).
 */
NBRBAuth2.prototype._resetData = function(withData) {
    if (withData === true) {
        this._DATA_ = genData();
    }
    if (!this._dataDefer || !this._dataDefer.isPending) {
        this._dataDefer = createDefer();
    }
    return this._dataDefer.promise;
}; /* _resetData */


/**
 * @private
 * @returns {(number|null)}
 */
NBRBAuth2.prototype._checkAuthToken = function(data) {
    return (data && (data.authTokenExpires > Date.now()) && data.authToken) || null;
}; /* _checkAuthToken */


/**
 * @public
 * @returns {Promise} Возвращает промис с authToken или null, если токена нет или он истёк.
 */
NBRBAuth2.prototype.getAuthToken = function() {
    return this.getData().then(this._checkAuthToken);
}; /* getAuthToken */

/**
 * @private
 * @returns {(number|null)}
 */
NBRBAuth2.prototype._checkAuthRefreshToken = function(data) {
    return (data && (data.authRefreshTokenExpires > Date.now()) && data.authRefreshToken) || null;
}; /* _checkAuthRefreshToken */


/**
 * @public
 * @returns {Promise} Возвращает промис с authRefreshToken или null, если токена нет или он истёк.
 */
NBRBAuth2.prototype.getAuthRefreshToken = function() {
    return this.getData().then(this._checkAuthRefreshToken);
}; /* getAuthRefreshToken */

/**
 * @private
 * @returns {(string|null)}
 */
NBRBAuth2.prototype._checkKeyContainer = function(data) {
    return (data && data.keyContainer) || null;
}; /* _checkKeyContainer */


/**
 * @public
 * @returns {Promise} Возвращает промис с контейнером, с которым авторизировались или null.
 */
NBRBAuth2.prototype.getKeyContainer = function() {
    return this.getData().then(this._checkKeyContainer);
}; /* getKeyContainer */


/**
 * @public
 * @return {Object} Возвращает опции, с которыми объект был инициализирован.
 */
NBRBAuth2.prototype.getOptions = function() {
    return Object.assign({}, this._options);
}; /* getOptions */


/**
 * @public
 * @return {Promise} Возвращает промис с состоянием аутентификации: true/false.
 */
NBRBAuth2.prototype.isAuthenticated = function() {
    return this.getData().then(function(data) {
        return !!this._checkAuthToken(data);
    }.bind(this));
}; /* isAuthenticated */


/**
 * Запрашивает с сервера и возвращает кодовую фразу.
 * @public
 * @return {Promise} Промис с кодовой фразой или ошибкой в случае неудачи.
 */
NBRBAuth2.prototype.authChallenge = function() {
    l('@nbrb-auth2', 'authChallenge() 1: START');
    return this._options.ajax({
        method: 'POST',
        url: this._options.baseUrl + 'authchallenge',
        withCredentials: this._options.withCredentials,
    })
    .then(responseSuccess, responseError)
    .then(function(response) { return response.data });
}; /* authChallenge */


/**
 * Метод аутентификации: оправляет запрос соответствующий на сервер.
 * @private
 * @param {string} endpoint - точка аутентификации на сервере.
 * @param {Object} data - данные, оотсылаемые на сервер для аутентификации.
 * @return {Promise} Возвращает промис объекта данных сессии или ошибку в случае неудачи.
 */
NBRBAuth2.prototype._auth = function(endpoint, data) {
    l('@nbrb-auth2', '_doAuth() 1: START');
    this._reset(true);///////?????????НЕ НАДО СЛАТЬ!!!

    return (this._options.ajax({
        method: 'POST',
        url: this._options.baseUrl + endpoint,
        withCredentials: this._options.withCredentials,
        data: data
    })
    .then(this._responseSuccessLogin.bind(this), this._responseErrorReset.bind(this))
    .then(function(data) {
        return (data && (data.errorMsg || data.status)) ? Promise.reject(data) : data;
    }));
}; /* _auth */


/**
 * Вызывает метод аутентификации, используя данные ЭЦП.
 * @public
 * @param {string} message - Кодовая фраза, полученная ранее с сервера.
 * @param {string} signature - Подписанные данные аутентификации.
 * @param {string} keyContainer - Контейнер с которым подписывали данные.
 * @param {string} [ignoreUserSwitch]
 * @param {string} [authToken]
 * @return {Promise} Возвращает промис объекта данных сессии или ошибку в случае неудачи.
 */
NBRBAuth2.prototype.auth = function(message, signature, keyContainer, ignoreUserSwitch, authToken, version) {
    l('@nbrb-auth2', 'auth() 1: START');
    var data = {
        Message: message,
        Signature: signature
    };

    /**
     * Контейнер делаем обязательным, даже если сервер его игнорирует,
     * так как его надо будет сохранить в данных (this._DATA_)
     */
    if (!keyContainer) {
        return E$('Не указан контейнер!', null, this._errorName);
    }

    // Так передаем контейнер только для портала
    data.Session = {KeyContainer: keyContainer};
    // Так передаем контейнер для всех приложений, кроме портала
    data.KeyContainer = keyContainer;

    if (typeof(ignoreUserSwitch) !== 'undefined') {
        //data.Session = data.Session || {};
        data.IgnoreUserSwitch = (ignoreUserSwitch === true);
    }

    if (authToken) {
        //data.Session = data.Session || {};
        data.AuthToken = authToken;
    }

    if (version) {
        data.Version = version;
    }

    return this._auth('auth', data);
}; /* auth */


/**
 * Вызывает метод аутентификации, используя имя пользователя и пароль.
 * @public
 * @param {string} username - Имя пользователя.
 * @param {string} password - Пароль.
 * @return {Promise} Возвращает промис объекта данных сессии или ошибку в случае неудачи.
 */
NBRBAuth2.prototype.credAuth = function(username, password) {
    l('@nbrb-auth2', 'credAuth() 1: START');
    return this._auth('credauth', {
        UserName: username,
        Password: password
    });
}; /* credAuth */


/**
 * Завершает сессию и удаляет аутентификационные данные.
 * @public
 * @param {boolean} isTimeout - whether it's automatic logout because of the inactivity timeout
 * @return {Promise} Возвращает промис результата или ошибку в случае неудачи.
 */
NBRBAuth2.prototype.logout = function(isTimeout) {
    l('@nbrb-auth2', 'logout()');
    return this.getAuthToken().then(function(authToken) {
        return (this._options.ajax({
            method: 'POST',
            url: this._options.baseUrl + 'deleteauth',
            data: {
                AuthToken: authToken,
                Timeout: !!isTimeout
            },
            withCredentials: this._options.withCredentials
        })
        .then(responseSuccess, responseError)
        .finally(function() {
            this._setData(genData(this.stateConstants.READY));
        }.bind(this)));
    }.bind(this));
}; /* logout */


/**
 * Обновляет с сервера аутентификационные данные: оба токена и время их истечения.
 * @public
 * @return {Promise} Промис объекта аутентификационных данных или ошибку в случае неудачи.
 */
NBRBAuth2.prototype.refresh = function(force) {
    l(['@nbrb-auth2', 6], 'refresh()');
    var getAuthRefreshToken = force ? Promise.resolve(this._checkAuthRefreshToken(this._DATA_)) : this.getAuthRefreshToken();
    //return this.getAuthRefreshToken().then(function(authRefreshToken) {
    return getAuthRefreshToken.then(function(authRefreshToken) {
        if (!authRefreshToken) {
            l(['@nbrb-auth2', 8], 'refresh(): authRefreshToken =', authRefreshToken);
            if (this._DATA_ && this._DATA_.authRefreshToken) {
                return Promise.reject({
                    status: -102,
                    errorMsg: 'Время сессии истекло.'
                });
            } else {
                return Promise.reject({
                    status: -104,
                    errorMsg: 'Время сессии истекло.'
                });
            }
        }
        l(['@nbrb-auth2', 7], 'refresh(): authRefreshToken =', authRefreshToken);

        /**
         * Переходим в режим ожидания данных и оповещаем всех об этом.
         */
        this._resetData();
        var data = Object.assign({}, this._DATA_);
        data.$id = genId();
        data.$state = this.stateConstants.LOADING;
        this._setData(data);

        /**
         * Ошибки соединения и запросов игнорируем (noop),
         * обрабатываем только данные которые получаем.
         */
        return (this._options.ajax({
            method: 'POST',
            url: this._options.baseUrl + 'refreshauthtoken',
            data: {
                AuthRefreshToken: authRefreshToken
            },
            withCredentials: this._options.withCredentials
        })
        .then(this._responseSuccessLogin.bind(this), function(error) {
            var waitTimeout = 2 * this._options.httpRequestTimeout;
            this._stopTimer();
            this._timerID = window.setTimeout(function() {
                l(['@nbrb-auth2', 8], 'refresh(): ERROR');
                this._stopTimer();
                this.refresh(true);
            }.bind(this), waitTimeout);
        }.bind(this)));
    }.bind(this));
}; /* refresh */


/**
 * Запрашивает с сервера и возвращает данные пользователя.
 * @public
 * @return {Promise} Промис объекта данных пользователя или ошибку в случае неудачи.
 */
NBRBAuth2.prototype.getCurrentUser = function() {
    return this.getAuthToken().then(function(authToken) {
        if (!authToken) {
            if (this._DATA_ && this._DATA_.authToken) {
                return Promise.reject({
                    status: -102,
                    errorMsg: 'Время сессии истекло.'
                });
            } else {
                return Promise.reject({
                    status: -103,
                    errorMsg: 'Время сессии истекло.'
                });
            }
        }

        var currentUserUrl = this._options.endpoints && this._options.endpoints.currentUser;
        if (!currentUserUrl) {
            return Promise.reject({
                status: -101,
                errorMsg: 'Невозможно получить данные пользователя: не указан endpoint.'
            });
        }

        return this._options.ajax({
            method: 'POST',
            url: this._options.baseUrl + currentUserUrl,
            withCredentials: this._options.withCredentials,
            data: {
                AuthToken: authToken
            }
        })
        .then(responseSuccess, responseError)
        .then(function(response) { return response.data; });
    }.bind(this));
}; /* getCurrentUser */


/**
 * Функция-слушатель (listener) события; в дальнейшем просто <слушатель>.
 * @callback listenerCallback
 * @param {Object|null} data - Данные аутентификации или "пустой" объект в случае, когда не залогинены.
 * @return {boolean} - Если слушатель вернёт true,
 *                     то вызов цепочки слушателей продолжится,
 *                     иначе вызов цепочки слушателей будет прерван и прекратится.
 */


/**
 * Добавление слушателя в конец цепочки.
 * @public
 * @param {string} type - Тип события: 'ON_IDLE_ALARM', 'ON_LOGIN', 'ON_LOGOUT', 'ON_UPDATE'.
 * @param {listenerCallback} listener - слушатель события.
 */
NBRBAuth2.prototype.on = function(type, listener) {
    this._events[type] = getEventListeners(this, type).concat([listener]);
}; /* on */


/**
 * Добавление разового слушателя в конец цепочки.
 * Вызов произведён будет только раз, затем этот слушатель будет удалён из цепочки.
 * @public
 * @param {string} type - Тип события: 'ON_IDLE_ALARM', 'ON_LOGIN', 'ON_LOGOUT', 'ON_UPDATE'.
 * @param {listenerCallback} listener - слушатель события.
 */
NBRBAuth2.prototype.once = function(type, listener) {
    this.on(type, function wrap() {
        this.off(type, wrap);
        listener.apply(this, arguments);
    });
}; /* once */


/**
 * Удаление слушателя.
 * @public
 * @param {string} type - Тип события: 'ON_IDLE_ALARM', 'ON_LOGIN', 'ON_LOGOUT', 'ON_UPDATE'.
 * @param {listenerCallback} listener - слушатель события.
 */
NBRBAuth2.prototype.off = function(type, listener) {
    this._events[type] = getEventListeners(this, type).filter(function(l) {
        return l !== listener;
    });
}; /* off */


/**
 * Вызывов цепочки слушателей заданного типа.
 * @public
 * @param {string} type - Тип события: 'ON_IDLE_ALARM', 'ON_LOGIN', 'ON_LOGOUT', 'ON_UPDATE'.
 * @param {Object} [data] - Данные, передаваемые слушателю.
 * @returns -
 */
NBRBAuth2.prototype.emit = function(type, data) {
    var i, listeners = getEventListeners(this, type);
    for (i=0; i<listeners.length; i++) {
        if (!listeners[i].call(this, data)) {
            break;
        }
    }
}; /* emit */


/**
 * Типы доступных событий:
 * @public
 */
NBRBAuth2.prototype.eventConstants = {
    ON_IDLE_ALARM: 'ON_IDLE_ALARM', // Событие, генерируемое при бездействии пользователя
                                    // за <idleAlarm> ms до принудительного разлогинивания.
    ON_LOGIN: 'ON_LOGIN',           // Событие, генерируемое при логине.
    ON_LOGOUT: 'ON_LOGOUT',         // Событие, генерируемое при разлогинивании.
    ON_UPDATE: 'ON_UPDATE'          // Событие, генерируемое при обновлении токенов.
}; /* eventConstants */


/**
 * Типы доступных событий:
 * @public
 */
NBRBAuth2.prototype._typeConstantsEx = {
    'ACTION': 'ACTION' // Сообщение, рассылаемое при действии пользователя.
                       // Список событий (действий пользователя) указывается в <idleActions>.
}; /* _typeConstantsEx */

/**
 * Типы состояний данных:
 *   LOADING: 0 - Данные еще не проинициализированы или обновляются. Промис незарезолвен.
 *   READY: 1   - Данные получены или проинициализированы "пустым" объектом. Промис зарезолвен.
 * @public
 */
NBRBAuth2.prototype.stateConstants = {
    LOADING: 0,
    READY: 1
}; /* stateConstants */


/* ************************************************************************************************/
function noop() {}


function genData(state) {
    return {
        $id: genId(),
        $state: state || 0
    };
}


function createDefer() {
    var deferred = {
        isPending: true,
    };
    deferred.promise = new Promise(function(resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    }).finally(function() {
        deferred.isPending = false;
    });
    return deferred;
}

/*
function checkPackages(p1, p2, p2Id, mismatchAlert) {
    / **
     * p1 - свои данные;
     * p2 - полученные данные;
     * p2Id - Id источника внешних данных.
     * /
    var msg;
    if (!p2) {
        msg = '@itbelcom/nbrb-auth2:\r\nВНИМАНИЕ!\r\nИспользуется устаревшая версия модуля.\r\nВкладка (iframe):\r\n    id = ' + p2Id;
    } else {
        var p = [];
        for(name in p1) {
            if (!p2[name] || (p2[name] !== p1[name])) {
                p.push(name + '@' + p1[name]);
            }
        }
        for(name in p2) {
            if (!p1[name]) {
                p.push(name + '@' + p2[name] + '*');
            }
        }
        if (p.length) {
            msg = '@itbelcom/nbrb-auth2:\r\nВНИМАНИЕ!\r\nВерсии следующих модулей различаются:\r\n    ' + p.join(',\r\n    ') + '\r\nВкладка (iframe):\r\n    id = ' + p2Id;
        }
    }
    if (msg) {
        console.warn(msg);
        if (mismatchAlert) {
            window.setTimeout(function() { alert(msg) }, 200);
        }
        return false;
    }
    return true;
}*/ /* checkPackages */


function throttle(func, wait) {
    var ctx, args, rtn, timeoutID; // caching
    var last = 0;
  
    return function throttled () {
        ctx = this;
        args = arguments;
        var delta = new Date() - last;
        if (!timeoutID) {
            if (delta >= wait) {
                call();
            } else {
                timeoutID = setTimeout(call, wait - delta);
            }
        }
        return rtn;
    };
  
    function call () {
        timeoutID = 0;
        last = +new Date();
        rtn = func.apply(ctx, args);
        ctx = null;
        args = null;
    }
} /* throttle */


//////////////////
// WEBPACK FOOTER
// ../node_modules/@itbelcom/nbrb-auth2/src/nbrb-auth2.js
// module id = 304
// module chunks = 0 1 2